import Name from "./Name";
import Actions from "./Actions";
import ViewActions from "./ViewActions";

const emergencyAccessComponents = {
  Name,
  Actions,
  ViewActions,
}

export default emergencyAccessComponents